export default __webpack_public_path__ + "static/media/936.62e16fc8.gif";